import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem('farmdash-theme');
    return saved || 'dark';
  });

  useEffect(() => {
    localStorage.setItem('farmdash-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const isDark = theme === 'dark';

  const colors = {
    bgPrimary: isDark ? 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900' : 'bg-gradient-to-br from-gray-50 via-white to-gray-100',
    bgCard: isDark ? 'bg-slate-800/50' : 'bg-white',
    bgCardHover: isDark ? 'bg-slate-700/30' : 'bg-gray-50',
    bgInput: isDark ? 'bg-slate-900' : 'bg-white',
    bgButton: isDark ? 'bg-slate-800' : 'bg-gray-100',
    bgButtonHover: isDark ? 'bg-slate-700' : 'bg-gray-200',
    border: isDark ? 'border-slate-700' : 'border-gray-200',
    borderLight: isDark ? 'border-slate-600' : 'border-gray-300',
    textPrimary: isDark ? 'text-white' : 'text-gray-900',
    textSecondary: isDark ? 'text-slate-400' : 'text-gray-600',
    textMuted: isDark ? 'text-slate-500' : 'text-gray-400',
    cardShadow: isDark ? '' : 'shadow-lg shadow-gray-200/50',
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, isDark, colors }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    return { 
      theme: 'dark', 
      toggleTheme: () => {}, 
      isDark: true,
      colors: {
        bgPrimary: 'bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900',
        bgCard: 'bg-slate-800/50',
        bgCardHover: 'bg-slate-700/30',
        bgInput: 'bg-slate-900',
        bgButton: 'bg-slate-800',
        bgButtonHover: 'bg-slate-700',
        border: 'border-slate-700',
        borderLight: 'border-slate-600',
        textPrimary: 'text-white',
        textSecondary: 'text-slate-400',
        textMuted: 'text-slate-500',
        cardShadow: '',
      }
    };
  }
  return context;
};